"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5606],{

/***/ 36697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Inline__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31987);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const DropdownMenu = (param)=>/*#__PURE__*/ {
    let { className ="" , shadow =true , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("dropdown-menu", !shadow && "no-shadow", className),
        ...props,
        children: children
    });
};
DropdownMenu.propTypes = {
    shadow: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    ..._Inline__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (DropdownMenu);


/***/ }),

/***/ 84586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2349);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25522);
/* harmony import */ var _Inline__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31987);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67924);
/* harmony import */ var _utils_DropDownProvider_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17223);
/* harmony import */ var _Header_context__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3197);










const DropdownMenuItemLink = (param)=>{
    let { className ="" , children , onClick =()=>{} , ...props } = param;
    const { onClose  } = (0,_Header_context__WEBPACK_IMPORTED_MODULE_8__/* .useHeader */ .g)();
    const { changeCurrentAction , initialAction , currentAction  } = (0,_utils_DropDownProvider_context__WEBPACK_IMPORTED_MODULE_7__/* .useDropDown */ .v)();
    const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((e)=>{
        changeCurrentAction(null);
        onClose();
        onClick(e);
        setTimeout(()=>{
            changeCurrentAction(initialAction);
        }, 100);
    }, [
        changeCurrentAction,
        initialAction,
        currentAction
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isBaseClassName: false,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("dropdown-menu-item-link", className),
        onClick: handleClick,
        ...props,
        children: children
    });
};
DropdownMenuItemLink.propTypes = {
    ..._Link__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes,
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_9__.func
};
const DropdownMenuItem = (param)=>/*#__PURE__*/ {
    let { className ="" , children , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_2__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .tF
    }  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_6__/* .classes */ .S)("dropdown-menu-item", ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_2__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingClassName */ .RB)(spacing), className),
        children: children
    });
};
DropdownMenuItem.propTypes = {
    ..._Inline__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
DropdownMenuItem.Link = DropdownMenuItemLink;
/* harmony default export */ __webpack_exports__["Z"] = (DropdownMenuItem);


/***/ }),

/***/ 65446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Title; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Inline/index.js + 1 modules
var Inline = __webpack_require__(31987);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js + 1 modules
var Icon = __webpack_require__(61672);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var sx = __webpack_require__(23720);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Triangle.js







const DropdownTriangle = (param)=>{
    let { isOpen , isOpenColor , color , size , spacing  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
        className: "dropdown-title__triangle",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.Z, {
            name: isOpen ? "angle-up" : "angle-down",
            spacing: (0,pureProps/* deepMergeProps */.p)({
                m: 0
            }, (0,pureProps/* default */.Z)(spacing)),
            color: isOpen ? isOpenColor : color,
            size: size
        })
    });
};
const { name: Triangle_name , ...IconPropTypes } = Icon/* default.propTypes */.Z.propTypes;
DropdownTriangle.propTypes = {
    isOpen: prop_types.bool,
    isOpenColor: sx/* colorPropTypes */.AK,
    ...IconPropTypes
};
/* harmony default export */ var Triangle = (DropdownTriangle);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/handlers.js
var handlers = __webpack_require__(22953);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Title.js









const DropdownTitle = (param)=>{
    let { isOpen =false , triangle =true , className ="" , children , childrenProps , triangleProps ={} , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
        className: (0,classes/* classes */.S)("dropdown-title", isOpen && "dropdown-title--open", className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Inline/* default */.Z, {
            ...childrenProps,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
                    className: "dropdown-title__text",
                    children: children
                }),
                triangle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Triangle, {
                    isOpen: isOpen,
                    ...triangleProps
                }) : null
            ]
        })
    });
};
DropdownTitle.propTypes = {
    isOpen: prop_types.bool,
    triangle: prop_types.bool,
    ...Inline/* default.propTypes */.Z.propTypes,
    childrenProps: (0,prop_types.shape)({
        ...Inline/* default.propTypes */.Z.propTypes
    }),
    triangleProps: (0,prop_types.shape)({
        color: sx/* colorPropTypes */.AK,
        isOpenColor: sx/* colorPropTypes */.AK,
        spacing: spacing/* spacingPropTypes */.Xj
    })
};
const DropdownTitleLink = (props)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownTitle, {
        Tag: "a",
        ...props,
        onClick: handlers/* prevent */.X$
    });
DropdownTitle.Link = DropdownTitleLink;
/* harmony default export */ var Title = (DropdownTitle);


/***/ }),

/***/ 38199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Dropdown_Dropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Inline/index.js + 1 modules
var Inline = __webpack_require__(31987);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/DropDownProvider/context.js
var context = __webpack_require__(17223);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Item.js







const DropdownItem = (param)=>{
    let { className ="" , isOpen , isMegaMenu , forwardRef , children , dropdown , ...props } = param;
    const { currentAction  } = (0,context/* useDropDown */.v)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Inline/* default */.Z, {
        forwardRef: forwardRef,
        className: (0,classes/* classes */.S)("dropdown", isMegaMenu && "dropdown--mega-menu", currentAction && "dropdown-action--".concat(currentAction), isOpen && "dropdown--open", className),
        ...props,
        children: children
    });
};
DropdownItem.propTypes = {
    className: prop_types.string,
    isOpen: prop_types.bool,
    isMegaMenu: prop_types.bool,
    dropdown: (0,prop_types.shape)({
        action: (0,prop_types.oneOf)([
            "onClick",
            "onHover",
            "onCSS"
        ]),
        sm: (0,prop_types.shape)({
            action: (0,prop_types.oneOf)([
                "onClick",
                "onHover",
                "onCSS"
            ])
        }),
        md: (0,prop_types.shape)({
            action: (0,prop_types.oneOf)([
                "onClick",
                "onHover",
                "onCSS"
            ])
        }),
        lg: (0,prop_types.shape)({
            action: (0,prop_types.oneOf)([
                "onClick",
                "onHover",
                "onCSS"
            ])
        })
    }),
    forwardRef: forward_ref/* default */.Z,
    children: prop_types.node
};
/* harmony default export */ var Item = (DropdownItem);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Body.js
/* eslint-disable react/forbid-prop-types */ 






const DropdownBody = (param)=>{
    let { Tag ="span" , settings , isOpen =false , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , align ="left" , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)("dropdown-body", align && "dropdown-body--align-".concat(align), isOpen && "dropdown-body--open", ...(0,props_utility/* utilityClassName */.b2)((0,pureProps/* deepMergeProps */.p)({
            bgColor: "white"
        }, (0,pureProps/* default */.Z)(utility))), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
DropdownBody.propTypes = {
    Tag: prop_types.string,
    isOpen: prop_types.bool,
    isPreRender: prop_types.bool,
    className: prop_types.string,
    settings: prop_types.object,
    align: (0,prop_types.oneOf)([
        "left",
        "right"
    ]),
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    children: prop_types.node
};
/* harmony default export */ var Body = (DropdownBody);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Title.js + 1 modules
var Title = __webpack_require__(65446);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/fn.js
var fn = __webpack_require__(46393);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/utils/click-outside.js

const isOutsideOf = (el)=>(param)=>{
        let { target  } = param;
        return !(el === target || el.contains(target));
    };
const onOutsideClick = (el, handler)=>{
    const documentClickHandler = (0,fn/* callIf */.bd)(isOutsideOf(el), handler);
    document.addEventListener("click", documentClickHandler);
    return ()=>document.removeEventListener("click", documentClickHandler);
};
/* harmony default export */ var click_outside = (onOutsideClick);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/utils/DropDownProvider/index.js
/* eslint-disable react/forbid-prop-types */ 




function DropDownProvider(param) {
    let { settings , changeCurrentAction , initialAction , currentAction , initialState =false , children  } = param;
    const [isOpen, setState] = (0,react.useState)(initialState);
    const containerRef = (0,react.useRef)(null);
    const open = (0,react.useCallback)(()=>{
        setState(true);
    }, []);
    const close = (0,react.useCallback)(()=>{
        setState(false);
    }, []);
    const toggle = (0,react.useCallback)(()=>{
        setState((state)=>!state);
    }, [
        isOpen
    ]);
    (0,react.useEffect)(()=>{
        const { current  } = containerRef;
        return current != null ? click_outside(current, close) : undefined;
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(context/* default.Provider */.Z.Provider, {
        value: {
            isOpen,
            changeCurrentAction,
            initialAction,
            currentAction,
            open,
            close,
            toggle,
            settings,
            containerRef
        },
        children: children
    });
}
DropDownProvider.propTypes = {
    settings: prop_types.object,
    initialAction: prop_types.string,
    currentAction: prop_types.string,
    changeCurrentAction: prop_types.func,
    initialState: prop_types.bool,
    children: prop_types.node
};
const DropDownConsumer = context/* default.Consumer */.Z.Consumer;
/* harmony default export */ var utils_DropDownProvider = (DropDownProvider);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/utils/useWindowSize.js

const useWindowSize = ()=>{
    const [windowSize, setWindowSize] = (0,react.useState)({
        width: undefined,
        height: undefined
    });
    (0,react.useEffect)(()=>{
        function handleResize() {
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
};
/* harmony default export */ var utils_useWindowSize = (useWindowSize);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/Dropdown.js










const dropdownProps = {
    action: null,
    sm: {
        action: null
    },
    md: {
        action: null
    },
    lg: {
        action: null
    }
};
const ON_CLICK = "onClick";
const ON_HOVER = "onHover";
const ON_CSS = "onCSS";
const Dropdown = (param)=>{
    let { dropdown ={
        ...dropdownProps
    } , className ="" , isMegaMenu =false , initialState , ...props } = param;
    const windowSize = utils_useWindowSize();
    const [currentAction, setCurrentAction] = (0,react.useState)(null);
    const pureDropdownProps = (0,pureProps/* deepMergeProps */.p)({
        action: ON_CLICK
    }, (0,pureProps/* default */.Z)(dropdown));
    const { action , sm , md , lg  } = pureDropdownProps;
    const getActionName = (0,react.useCallback)((device)=>{
        const deviceActionName = device && typeof device.action === "string" ? device.action : "";
        return typeof device === "string" ? device : deviceActionName;
    }, []);
    const width = (0,react.useMemo)(()=>+windowSize.width, [
        windowSize
    ]);
    const isAll = (0,react.useMemo)(()=>getActionName(action), [
        getActionName
    ]);
    const isSM = (0,react.useMemo)(()=>width < 640 && getActionName(sm), [
        width,
        getActionName
    ]);
    const isMD = (0,react.useMemo)(()=>width >= 640 && width < 1024 && getActionName(md), [
        width,
        getActionName
    ]);
    const isLG = (0,react.useMemo)(()=>width >= 1024 && getActionName(lg), [
        width,
        getActionName
    ]);
    const detectDevice = (0,react.useCallback)((actionName, param)=>{
        let { ...devices } = param;
        return devices.isAll === actionName && !devices.isSM && !devices.isMD && !devices.isLG || devices.isSM === actionName || devices.isMD === actionName || devices.isLG === actionName;
    }, []);
    const dataOnClick = (0,react.useMemo)(()=>({
            status: detectDevice(ON_CLICK, {
                isAll,
                isSM,
                isMD,
                isLG
            }),
            key: ON_CLICK
        }), [
        detectDevice,
        isAll,
        isSM,
        isMD,
        isLG
    ]);
    const dataOnHover = (0,react.useMemo)(()=>({
            status: detectDevice(ON_HOVER, {
                isAll,
                isSM,
                isMD,
                isLG
            }),
            key: ON_HOVER
        }), [
        detectDevice,
        isAll,
        isSM,
        isMD,
        isLG
    ]);
    const dataOnCSS = (0,react.useMemo)(()=>({
            status: detectDevice(ON_CSS, {
                isAll,
                isSM,
                isMD,
                isLG
            }),
            key: ON_CSS
        }), [
        detectDevice,
        isAll,
        isSM,
        isMD,
        isLG
    ]);
    const actionHandler = (0,react.useCallback)((fn)=>{
        let actionProps = {};
        if (dataOnHover.status) {
            actionProps = {
                onMouseEnter: fn,
                onMouseLeave: fn
            };
        }
        if (dataOnClick.status) {
            actionProps = {
                onClick: fn
            };
        }
        if (dataOnCSS.status) {
            actionProps = ()=>{};
        }
        return actionProps;
    }, [
        dataOnHover,
        dataOnClick,
        dataOnCSS
    ]);
    const initialAction = (0,react.useMemo)(()=>{
        let result;
        switch(true){
            case dataOnHover.status:
                result = dataOnHover.key;
                break;
            case dataOnCSS.status:
                result = dataOnCSS.key;
                break;
            case dataOnClick.status:
                result = dataOnClick.key;
                break;
            default:
                result = null;
                break;
        }
        return result;
    }, [
        dataOnHover,
        dataOnClick,
        dataOnCSS
    ]);
    const handleChangeCurrentAction = (0,react.useCallback)((value)=>setCurrentAction(value), [
        initialAction,
        currentAction,
        setCurrentAction
    ]);
    (0,react.useEffect)(()=>{
        setCurrentAction(initialAction);
    }, [
        setCurrentAction,
        initialAction
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(utils_DropDownProvider, {
        initialAction: initialAction,
        currentAction: currentAction,
        changeCurrentAction: handleChangeCurrentAction,
        settings: pureDropdownProps,
        isMegaMenu: isMegaMenu,
        initialState: initialState,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DropDownConsumer, {
            children: (param)=>/*#__PURE__*/ {
                let { isOpen , toggle , containerRef  } = param;
                return (0,jsx_runtime.jsx)(Item, {
                    className: className,
                    isOpen: isOpen,
                    isMegaMenu: isMegaMenu,
                    forwardRef: containerRef,
                    dropdown: pureDropdownProps,
                    ...actionHandler(toggle),
                    ...props
                });
            }
        })
    });
};
Dropdown.propTypes = {
    ...Item.propTypes,
    className: prop_types.string,
    initialState: prop_types.bool
};
const Dropdown_Body = (props)=>{
    const { isOpen , settings  } = (0,context/* useDropDown */.v)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Body, {
        settings: settings,
        isOpen: isOpen,
        ...props
    });
};
const Dropdown_Title = (props)=>{
    const { isOpen  } = (0,context/* useDropDown */.v)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Title/* default */.Z, {
        isOpen: isOpen,
        ...props
    });
};
Dropdown.Title = Dropdown_Title;
Dropdown.Body = Dropdown_Body;
/* harmony default export */ var Dropdown_Dropdown = (Dropdown);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/index.js



/***/ }),

/***/ 61672:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Icon_Icon; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureFC.js
var pureFC = __webpack_require__(19738);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var sx = __webpack_require__(23720);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/Icon.js







const iconPrefix = "wrapper";
const legacyNames = new Map([
    [
        "download",
        "arrow-to-bottom"
    ],
    [
        "cart",
        "shopping-cart"
    ],
    [
        "profile",
        "user-alt"
    ],
    [
        "arrow-long-left",
        "long-arrow-left"
    ],
    [
        "arrow-long-right",
        "long-arrow-right"
    ],
    [
        "arrow-left-2",
        "arrow-left"
    ],
    [
        "arrow-right-2",
        "arrow-right"
    ]
]);
const Icon = (param)=>/*#__PURE__*/ {
    let { name , size , className , Tag ="i" , color , animate =false , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , ...props } = param;
    return (0,jsx_runtime.jsx)(Tag, {
        className: (0,classes/* classes */.S)("".concat(iconPrefix, "-icon"), "".concat(iconPrefix, "-icon-").concat(legacyNames.get(name) || name), size && "".concat(iconPrefix, "-icon--").concat(size), animate && "".concat(iconPrefix, "-icon--animate"), color && "text-color-".concat(color), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Icon.propTypes = {
    name: (0,prop_types.oneOf)([
        "angle-down",
        "angle-left",
        "angle-right",
        "angle-up",
        "mac",
        "arrow-left",
        "arrow-right",
        "arrow-to-bottom",
        "check",
        "chevron-down",
        "chevron-left",
        "chevron-right",
        "chevron-up",
        "clock",
        "copy",
        "debug",
        "long-arrow-left",
        "long-arrow-right",
        "play",
        "plus",
        "question-circle",
        "linux",
        "linux_rpm",
        "search",
        "shopping-cart",
        "sort",
        "times",
        "linux_deb",
        "user",
        "user-alt",
        "windows",
        "facebook-f",
        "twitter",
        "linkedin-in",
        "youtube",
        "facebook-square",
        "linkedin-square",
        "twitter-square",
        "youtube-alt",
        "dna",
        "book",
        "graduation-cap",
        "life-ring",
        "question",
        "question-circle-1",
        "video",
        "bullhorn",
        "file-star",
        "link-ext",
        "rocket-launch",
        "comments-alt",
        "instagram-square",
        "calendar-alt"
    ]).isRequired,
    size: (0,prop_types.oneOf)([
        "xs",
        "s",
        "m",
        "l",
        "xl",
        "xxl",
        "xxxl",
        "xxxxl"
    ]),
    color: sx/* colorPropTypes */.AK,
    animate: prop_types.bool,
    className: prop_types.string,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    Tag: prop_types.elementType
};
/* harmony default export */ var Icon_Icon = ((0,pureFC/* default */.Z)(Icon));

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Icon/index.js



/***/ }),

/***/ 31987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Inline_Inline; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/forward-ref/index.js
var forward_ref = __webpack_require__(52418);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Inline/Inline.js








const Inline = (param)=>/*#__PURE__*/ {
    let { Tag ="span" , forwardRef , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , ...props } = param;
    return (0,jsx_runtime.jsx)(Tag, {
        ref: forwardRef,
        className: (0,classes/* classes */.S)(...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props
    });
};
Inline.propTypes = {
    Tag: (0,prop_types.oneOfType)([
        (0,prop_types.oneOf)([
            "span",
            "i",
            "em",
            "b",
            "strong"
        ]),
        prop_types.elementType
    ]),
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    className: prop_types.string,
    forwardRef: forward_ref/* default */.Z
};
/* harmony default export */ var Inline_Inline = (Inline);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Inline/index.js



/***/ }),

/***/ 88881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_forward_ref__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52418);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const NavbarItem = (param)=>{
    let { Tag ="li" , forwardRef , itemIcon , enable =true , secondary =false , className , ...props } = param;
    return enable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ref: forwardRef,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)(secondary && "secondary-nav__item", secondary && itemIcon && "secondary-nav__item-".concat(itemIcon), className),
        ...props
    }) : null;
};
NavbarItem.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOfType)([
        (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
            "li"
        ]),
        prop_types__WEBPACK_IMPORTED_MODULE_4__.elementType
    ]),
    itemIcon: (0,prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf)([
        "search"
    ]),
    enable: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    secondary: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    forwardRef: _utils_forward_ref__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
};
/* harmony default export */ __webpack_exports__["Z"] = (NavbarItem);


/***/ }),

/***/ 81453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25522);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _Header_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3197);
/* harmony import */ var _utils_DropDownProvider_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17223);







const NavbarItemLink = (param)=>{
    let { Tag =_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z , className , onClick =()=>{} , ...props } = param;
    const isLink = Tag === _Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
    const config = isLink && {
        isBaseClassName: false
    };
    const { changeCurrentAction , initialAction , currentAction  } = (0,_utils_DropDownProvider_context__WEBPACK_IMPORTED_MODULE_5__/* .useDropDown */ .v)();
    const { onClose  } = (0,_Header_context__WEBPACK_IMPORTED_MODULE_4__/* .useHeader */ .g)();
    const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((e)=>{
        if (isLink) {
            changeCurrentAction(null);
        }
        onClick(e);
        if (isLink) {
            onClose();
            setTimeout(()=>{
                changeCurrentAction(initialAction);
            }, 100);
        }
    }, [
        changeCurrentAction,
        initialAction,
        currentAction,
        isLink
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, {
        ...config,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("nav__item-link", className),
        onClick: handleClick,
        ...props
    });
};
NavbarItemLink.propTypes = {
    Tag: (0,prop_types__WEBPACK_IMPORTED_MODULE_6__.oneOfType)([
        prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
        prop_types__WEBPACK_IMPORTED_MODULE_6__.elementType
    ]),
    onClick: prop_types__WEBPACK_IMPORTED_MODULE_6__.func,
    href: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_6__.string
};
/* harmony default export */ __webpack_exports__["Z"] = (NavbarItemLink);


/***/ }),

/***/ 37762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Navbar_Navbar; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/Navbar.js




const Navbar = (param)=>/*#__PURE__*/ {
    let { nav , type =null , className ="" , children , inverted  } = param;
    return (0,jsx_runtime.jsx)("ul", {
        className: (0,classes/* classes */.S)("nav", nav && "".concat(nav, "-nav"), type && "nav-type-".concat(type), inverted && "nav--inverted", className),
        children: children
    });
};
Navbar.propTypes = {
    nav: (0,prop_types.oneOf)([
        "primary",
        "secondary"
    ]).isRequired,
    type: (0,prop_types.oneOf)([
        1
    ]),
    className: prop_types.string,
    children: prop_types.node,
    inverted: prop_types.bool
};
/* harmony default export */ var Navbar_Navbar = (Navbar);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/index.js



/***/ }),

/***/ 1385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Dropdown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38199);
/* harmony import */ var _Dropdown_Menu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36697);





const NavbarDropdownMenu = (param)=>{
    let { isList =true , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Dropdown__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Body */ .Z.Body, {
        className: className,
        ...props,
        children: isList ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Dropdown_Menu__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            children: children
        }) : children
    });
};
NavbarDropdownMenu.propTypes = {
    isList: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["Z"] = (NavbarDropdownMenu);


/***/ }),

/***/ 10110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Dropdown_MenuItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84586);



const NavbarDropdownMenuItem = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Dropdown_MenuItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        ...props,
        children: children
    });
};
NavbarDropdownMenuItem.propTypes = {
    ..._Dropdown_MenuItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
const NavbarDropdownMenuItemLink = (param)=>{
    let { className , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Dropdown_MenuItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Link */ .Z.Link, {
        className: className,
        ...props
    });
};
NavbarDropdownMenuItemLink.propTypes = {
    ..._Dropdown_MenuItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Link.propTypes */ .Z.Link.propTypes
};
NavbarDropdownMenuItem.Link = NavbarDropdownMenuItemLink;
/* harmony default export */ __webpack_exports__["Z"] = (NavbarDropdownMenuItem);


/***/ }),

/***/ 36555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Navbar_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81453);
/* harmony import */ var _Dropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38199);




const NavbarDropdownTitle = (param)=>{
    let { children , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Navbar_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: _Dropdown__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Title */ .Z.Title,
        ...props,
        children: children
    });
};
NavbarDropdownTitle.propTypes = {
    ..._Dropdown__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Title.propTypes */ .Z.Title.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (NavbarDropdownTitle);


/***/ }),

/***/ 86210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ NavbarDropdown_NavbarDropdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Dropdown/index.js + 6 modules
var Dropdown = __webpack_require__(38199);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Navbar/Item.js
var Item = __webpack_require__(88881);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarDropdown/NavbarDropdown.js






const DropdownUlItem = (param)=>/*#__PURE__*/ {
    let { ...props } = param;
    return (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
        Tag: "li",
        ...props
    });
};
const NavbarDropdown = (param)=>{
    let { isMegaMenu =false , isSecondaryNav =false , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Item/* default */.Z, {
        Tag: DropdownUlItem,
        secondary: isSecondaryNav,
        isMegaMenu: isMegaMenu,
        className: (0,classes/* classes */.S)(className),
        children: children
    });
};
NavbarDropdown.propTypes = {
    isMegaMenu: prop_types.bool,
    isSecondaryNav: prop_types.bool,
    ...Dropdown/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var NavbarDropdown_NavbarDropdown = (NavbarDropdown);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/NavbarDropdown/index.js



/***/ }),

/***/ 17223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useDropDown; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const context = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    initialAction: null,
    currentAction: null,
    isOpen: false,
    changeCurrentAction: ()=>{},
    open: ()=>{},
    close: ()=>{},
    toggle: ()=>{},
    settings: {},
    containerRef: ()=>{}
});
const useDropDown = ()=>(0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(context);
/* harmony default export */ __webpack_exports__["Z"] = (context);


/***/ }),

/***/ 22953:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gy": function() { return /* binding */ handleWith; },
/* harmony export */   "X$": function() { return /* binding */ prevent; }
/* harmony export */ });
/* unused harmony export stop */
const prevent = (event)=>{
    return event === null || event === void 0 ? void 0 : event.preventDefault();
};
const stop = (event)=>{
    return event === null || event === void 0 ? void 0 : event.stopPropagation();
};
const handleWith = function() {
    for(var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++){
        handlers[_key] = arguments[_key];
    }
    const fnHandlers = handlers.filter((handler)=>typeof handler === "function");
    return (event)=>fnHandlers.forEach((handler)=>handler(event));
};


/***/ })

}]);